import {MediaCardMetadata} from '@wandb/weave/common/types/media';

import {Dimensions} from './types';

export function getGroupedMediaDimensions(
  metadata: MediaCardMetadata | null
): Dimensions | null {
  if (metadata == null) {
    return null;
  }

  if (metadata._type === 'table-file') {
    if (metadata.size == null) {
      return null;
    }
    return {
      width: metadata.size,
      height: metadata.size,
    };
  }

  const {width, height, grouping} = metadata;
  if (width == null || height == null) {
    return null;
  }

  return {
    width: width * (grouping ?? 1),
    height,
  };
}
